import { render, staticRenderFns } from "./DotIcon.vue?vue&type=template&id=17fc2ced"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('17fc2ced')) {
      api.createRecord('17fc2ced', component.options)
    } else {
      api.reload('17fc2ced', component.options)
    }
    module.hot.accept("./DotIcon.vue?vue&type=template&id=17fc2ced", function () {
      api.rerender('17fc2ced', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/DotIcon.vue"
export default component.exports